
import { 
  getJobTypeLabel, 
  getQuestionTypeLabel, 
  getUserRoleLabel, 
  getCandidateStatusLabel, 
  getEvaluationRoundLabel,
  getBranchTypeLabel,
  getQualificationTypeLabel
} from '@/types/enums';

export const formatJobType = (jobType: string | null | undefined): string => {
  if (!jobType) return 'No Type';
  return getJobTypeLabel(jobType as any);
};

export const formatQuestionType = (questionType: string | null | undefined): string => {
  if (!questionType) return 'Unknown';
  return getQuestionTypeLabel(questionType as any);
};

export const formatUserRole = (role: string | null | undefined): string => {
  if (!role) return 'Unknown';
  return getUserRoleLabel(role as any);
};

export const formatCandidateStatus = (status: string | null | undefined): string => {
  if (!status) return 'Unknown';
  return getCandidateStatusLabel(status as any);
};

export const formatEvaluationRound = (round: string | null | undefined): string => {
  if (!round) return 'Unknown';
  return getEvaluationRoundLabel(round as any);
};

// Export the getEvaluationRoundLabel function directly
export { getEvaluationRoundLabel } from '@/types/enums';
// Export the getCandidateStatusLabel function for components that need just the label helper
export { getCandidateStatusLabel } from '@/types/enums';

export const formatBranchType = (branch: string | null | undefined): string => {
  if (!branch) return 'Unknown';
  return getBranchTypeLabel(branch as any);
};

export const formatQualificationType = (qualification: string | null | undefined): string => {
  if (!qualification) return 'Unknown';
  return getQualificationTypeLabel(qualification as any);
};

export const formatScore = (score: number | null | undefined): string => {
  if (score === null || score === undefined) return '0';
  return score.toString();
};

export const formatCGPA = (cgpa: number | null | undefined): string => {
  if (cgpa === null || cgpa === undefined) return 'N/A';
  return cgpa.toFixed(2);
};

export const formatDate = (date: string | null | undefined): string => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-GB');
};

export const formatDateTime = (date: string | null | undefined): string => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleString('en-GB');
};
